import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";

import { StringValue } from "./StringValue";
import { StringArray } from "./StringArray";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Upgrade Buildings">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringValue
          label={"Selected City"}
          value={task.taskstatusdetail.targetcity.cityname}
        />
        <StringArray
          label={"Buildings To Include"}
          array={task.taskstatusdetail.userInputIncludeBuildingNames}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Processing/Checking building:"}
          value={`${task.taskstatusdetail.currentbuildingname}: Lv
          ${task.taskstatusdetail.currentbuildinglevel}`}
        />

        {task.taskstatusdetail.useHGS !== undefined && (
          <>
            <StringValue
              label={"Use HourGlasses?"}
              value={task.taskstatusdetail.useHGS}
            />
            {task.taskstatusdetail.timeleft !== undefined &&
              task.taskstatusdetail.useHGS === false && (
                <StringValue
                  label={"Time Left for this building to upgrade"}
                  value={task.taskstatusdetail.timeleft}
                />
              )}
          </>
        )}
        <StringArray
          label={"Processed Buildings:"}
          array={task.taskstatusdetail.processedbuildings}
          valueParser={(item) => (
            <>
              {item.bname}
              {item.sblevel && <span>(InitLv:{item.sblevel})</span>} :
              {item.blevel}
            </>
          )}
        />
        <StringArray
          label={"Building Report:"}
          array={task.taskstatusdetail.buildingreport}
          valueParser={(item) => (
            <span style={{ fontSize: "10px", fontWeight: "normal" }}>
              {item.bstatus}
            </span>
          )}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
